import { useMemo } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { DayGroup } from "./DayGroup";
import { groupEntriesByDay } from "./groupByDay";
import * as styles from "./styles_vanilla.css";
import type { ActivityFeedProps } from "./types";

export type { ActivityFeedEntry, ActivityFeedProps } from "./types";

export const ActivityFeed = ({
  entries,
  emptyLabel = "No activity yet",
}: ActivityFeedProps) => {
  const dayGroups = useMemo(() => groupEntriesByDay(entries), [entries]);

  if (dayGroups.length === 0) {
    return (
      <Flex justifyContent="center" className={styles.emptyContainer}>
        <Text variant="regular-md" color={Colors.Neutral600}>
          {emptyLabel}
        </Text>
      </Flex>
    );
  }

  return (
    <Flex className={styles.container} flexDirection="column">
      {dayGroups.map((group) => (
        <DayGroup key={group.dayKey} group={group} />
      ))}
    </Flex>
  );
};
